const BASE_URL = "medlyves-server-thailand-1039339270759.asia-southeast1.run.app";

const API_PREFIX = process.env.API_PREFIX || "https://";
const WS_PREFIX = process.env.WS_PREFIX || "wss://";

export const API_URL = `${API_PREFIX}${BASE_URL}`;
export const WS_URL = `${WS_PREFIX}${BASE_URL}`;
